<script>
    import {onMount, createEventDispatcher} from "svelte";
    const dispatch = createEventDispatcher();

    export let value = '';
    export let mce_opts = {};
    export let name = "mceField";
    export let classNames = "";
    export let showSubmitOnEnter = false;

    let submitOnEnter = false;


    let default_mce_opts = {
        toolbar: "undo redo | formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat",
        plugins: "lists",
        menubar: false
    }

    let editor;
    let textarea;
    let tool_div;

    function updateValue() {
        value = editor.getContent();
    }

    function updateContent(value) {
        if (editor) {
            editor.setContent(value);
        }
    }

    if (mce_opts.browser_spellcheck == undefined) {
        mce_opts.browser_spellcheck = true;
    }

    function toggleSubmitOnEnter() {
        submitOnEnter = !submitOnEnter;

        window.localStorage.setItem('katana.submitOnEnter', JSON.stringify(submitOnEnter));
    }

    onMount(function() {
        let combined_mce_opts = Object.assign(default_mce_opts, mce_opts);

        if (showSubmitOnEnter) {
            let savedSubmitOnEnter = window.localStorage.getItem("katana.submitOnEnter");
            if (savedSubmitOnEnter) {
                try {
                    submitOnEnter = JSON.parse(savedSubmitOnEnter)
                } catch (e) {
                    submitOnEnter = false;
                }
            }
        }

        let options = {
            ...combined_mce_opts,
            target: textarea,
            setup: (e) => {
                editor = e;
                editor.on("blur", updateValue);

                // TinyMCE is not removing this div when we unmount it
                // so we manually get a handle on it. There is a chance
                // that this may cause a race condition since I haven't
                // found a way to definitively get a handle on the element
                // so I grab the last one in the dom, which theoretically
                // was the one added for this editor.

                editor.on("init", (ev) => {
                    tool_div = Array.from(document.getElementsByClassName('tox-tinymce-aux')).pop();
                })

                if (showSubmitOnEnter) {
                    editor.on("keydown", (ev) => {
                        if (submitOnEnter && ev.keyCode == 13) {
                            editor.save();
                            dispatch("submit");
                            return false
                        }
                    })
                }
            }
        }
        tinymce.init(options);

        return () => {
            // remove the toolbar div -- see comment above
            if (tool_div) {
                tool_div.parentNode.removeChild(tool_div);
            }

            editor.off();
            editor.remove();
            editor.destroy();
            editor = undefined;
        }
    });

    $: updateContent(value);
</script>

<textarea class={classNames} name={name} bind:this={textarea} {value}></textarea>
{#if showSubmitOnEnter}
    <span class="is-pulled-left tags">
        <span class="pointer tag is-info" class:is-light={!submitOnEnter} on:click={toggleSubmitOnEnter}>Submit on Enter</span>
    </span>
{/if}

<style>
    .tags {
        margin-top: 1rem;
        margin-bottom: 0;
    }
</style>